// Normal icons
import { Bank } from '../icons/bank';
import { Bolt } from '../icons/bolt';
import { Cake } from '../icons/cake';
import { Calendar } from '../icons/calendar';
import { Checkmark } from '../icons/checkmark';
import { Diamond } from '../icons/diamond';
import { DoubleCheckmark } from '../icons/double-checkmark';
import { ErrorGhost } from '../icons/error-ghost';
import { Files } from '../icons/files';
import { Invoice } from '../icons/invoice';
import { Mail } from '../icons/mail';
import { Phone } from '../icons/phone';
import { Plant } from '../icons/plant';
import { SwishSymbol } from '../icons/swish-symbol';
import { Tokenized } from '../icons/tokenized';
import { VippsSymbol } from '../icons/vipps-symbol';
import { ZaverLogoObj } from '../icons/zaver-logo';

// Circle icons
import { BankSignalCircle } from '../icons-circle/bank-signal-circle';
import { DoubleCheckmarkCircle } from '../icons-circle/double-checkmark-circle';
import { InvoiceCircle } from '../icons-circle/invoice-circle';
import { MailCircle } from '../icons-circle/mail-circle';
import { PhoneCircle } from '../icons-circle/phone-circle';
import { PiggyCircle } from '../icons-circle/piggy-circle';
import { TPCircle } from '../icons-circle/tp-circle';
import { UserCircle } from '../icons-circle/user-circle';

// UI Icons
import { BackArrow } from '../icons-UI/back-arrow';
import { ChevronLeft } from '../icons-UI/chevron-left';
import { ChevronRight } from '../icons-UI/chevron-right';
import { ChevronUp } from '../icons-UI/chevron-up';
import { ChevronDown } from '../icons-UI/chevron-down';
import { Close } from '../icons-UI/close';
import { Error } from '../icons-UI/error';
import { MagnifyingGlass } from '../icons-UI/magnifying-glass';
import { Info } from '../icons-UI/info';
import { Warning } from '../icons-UI/warning';

// External Icons
import { AppleLogo } from '../icons-external/apple-logo';
import { BankIDse } from '../icons-external/bankID-se';
import { BankIDno } from '../icons-external/bankID-no';
import { GoogleStore } from '../icons-external/google-store-logo';
import { SwishLogo } from '../icons-external/swish-logo';
import { SwishLogoAlt } from '../icons-external/swish-logo-alt';
import { Trustly } from '../icons-external/trustly';
import { VippsLogo } from '../icons-external/vipps-logo';
import { VippsOrange } from '../icons-external/vipps-logo-orange';

export const ZAVER_ICON_DATA = {
  // ---- Base Icons ----
  bank: Bank,
  bolt: Bolt,
  cake: Cake,
  calendar: Calendar,
  checkmark: Checkmark,
  diamond: Diamond,
  doubleCheckmark: DoubleCheckmark,
  errorGhost: ErrorGhost,
  files: Files,
  invoice: Invoice,
  mail: Mail,
  phone: Phone,
  plant: Plant,
  swishSymbol: SwishSymbol,
  tokenized: Tokenized,
  vippsSymbol: VippsSymbol,
  zaverLogoObj: ZaverLogoObj,

  // ---- Base Icons Circle ----
  bankSignalCircle: BankSignalCircle,
  doubleCheckmarkCircle: DoubleCheckmarkCircle,
  invoiceCircle: InvoiceCircle,
  mailCircle: MailCircle,
  phoneCircle: PhoneCircle,
  piggyCircle: PiggyCircle,
  tpCircle: TPCircle,
  userCircle: UserCircle,

  // ---- UI icons ----
  backArrow: BackArrow,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  chevronDown: ChevronDown,
  close: Close,
  error: Error,
  info: Info,
  magnifyingGlass: MagnifyingGlass,
  warning: Warning,

  // ---- External Icons ----
  appleLogo: AppleLogo,
  bankIDse: BankIDse,
  bankIDno: BankIDno,
  googleStore: GoogleStore,
  trustly: Trustly,
  swishLogo: SwishLogo,
  swishLogoAlt: SwishLogoAlt,
  vippsLogo: VippsLogo,
  vippsOrange: VippsOrange,
};

export type ZaverIconFormat = string | Record<string, string>;
export type ZaverIconNameValue = keyof typeof ZAVER_ICON_DATA;
